module.exports = __webpack_public_path__ + "img/dpd-cod-alternate.a8c01f95.png";